import { render, staticRenderFns } from "./SongPreview.vue?vue&type=template&id=22ed5934&scoped=true"
import script from "./SongPreview.vue?vue&type=script&lang=ts"
export * from "./SongPreview.vue?vue&type=script&lang=ts"
import style0 from "./SongPreview.vue?vue&type=style&index=0&id=22ed5934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed5934",
  null
  
)

export default component.exports